// extracted by mini-css-extract-plugin
module.exports = {"header":"cv_cc","heading":"cv_ce","subheading":"cv_cw","eventLink":"cv_cx","logoGrid":"cv_cy","logo":"cv_cz fg_fm fg_fr fg_f2"};